<template>
    <div>
        <research-list :list="list" :type="type"></research-list>
    </div>
</template>
<script>
import researchList from '../../components/researchList'
export default {
    name:"patent",
    components: { researchList },
    data(){
        return {
            list:[
                {item:11}
            ],
            type:2
        }
    },
    methods(){}
}
</script>
<style lang="less" scoped>

</style>